import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { Card } from '../Card';
import { Divider } from '../Divider';
import { FullRow, Row } from '../Layout';
import styles from './MobileRecordCard.module.scss';
export function MobileRecordCard(param) {
    let { rows, inlineItems = [], actions, footer, skin, className, rowClassName, leadingRowClassName, actionsClassName, testId } = param;
    return /*#__PURE__*/ _jsx(Card, {
        // eslint-disable-next-line custom/no-hardcoded-nobi-in-seagull -- WHY: non-actionable Card; rendered as a div with no onClick, so it never emits BI (Card only logs when as==='button').
        noBi: true,
        autoHeight: true,
        padding: "s",
        skin: skin,
        borderRadius: "m",
        borderSkin: "default",
        testId: testId,
        className: cn(styles.card, className),
        disableSeparator: true,
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                rows.map((row, index)=>{
                    const isLeadingRow = index === 0;
                    const rowBody = /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            row.dividerBefore === true && /*#__PURE__*/ _jsx("div", {
                                "data-testid": row.dividerTestId,
                                children: /*#__PURE__*/ _jsx(Divider, {
                                    margin: 4,
                                    skin: skin === 'mobileGray' ? 'white' : undefined
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: cn(styles.cardRow, rowClassName, {
                                    [styles.spaceBetween]: row.spaceBetween === true,
                                    [styles.strong]: row.emphasis === 'strong'
                                }),
                                "data-testid": row.testId,
                                children: [
                                    typeof row.label === 'function' ? row.label(styles.cardRowLabel) : row.label,
                                    typeof row.value === 'function' ? row.value(cn(styles.cardRowValue, {
                                        [styles.withInlineItems]: isLeadingRow && inlineItems.length > 0
                                    })) : row.value,
                                    isLeadingRow && inlineItems.map((item)=>/*#__PURE__*/ _jsx(Row, {
                                            alignItems: "center",
                                            className: styles.cardRowInline,
                                            testId: item.testId,
                                            children: item.content
                                        }, item.key))
                                ]
                            })
                        ]
                    });
                    return /*#__PURE__*/ _jsxs(React.Fragment, {
                        children: [
                            isLeadingRow && actions != null ? /*#__PURE__*/ _jsxs(FullRow, {
                                alignItems: "center",
                                justifyContent: "space-between",
                                className: leadingRowClassName,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: styles.rowBeforeActions,
                                        children: rowBody
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: cn(styles.actions, actionsClassName),
                                        children: actions
                                    })
                                ]
                            }) : rowBody,
                            row.secondaryValue != null && /*#__PURE__*/ _jsx("div", {
                                className: cn(styles.cardRow, rowClassName),
                                "data-testid": row.secondaryTestId,
                                children: typeof row.secondaryValue === 'function' ? row.secondaryValue(styles.cardRowValue) : row.secondaryValue
                            })
                        ]
                    }, row.key);
                }),
                footer != null && /*#__PURE__*/ _jsx("div", {
                    className: styles.footer,
                    children: footer
                })
            ]
        })
    });
}
